import { render, staticRenderFns } from "./ReviewSeminar.vue?vue&type=template&id=e539b40e&scoped=true&"
import script from "./ReviewSeminar.vue?vue&type=script&lang=js&"
export * from "./ReviewSeminar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e539b40e",
  null
  
)

export default component.exports